var LoginPage = require('./login')

module.exports = {
    TRANSFERRED : "DITRANSFER",
    TRANSIT : "TRANSIT",
    Top_5_items : "5 Barang Teratas",
    You_have_no_items_assigned_to_any_category_yet : "Anda belum memiliki barang yang ditetapkan ke kategori apa pun",
    You_have_no_items_assigned_to_any_supplier_yet : "Anda belum memiliki barang yang ditetapkan untuk pemasok mana pun",
    access : "Akses",
    access_right : "ak Akse",
    access_to_customer_base : "Akses ke basis pelanggan",
    access_to_live_chat_support : "Akses ke dukungan obrolan langsung",
    access_to_jubelio: "Mengakses Integrasi Jubelio",
    edit_b2b_store: "Kelola Toko B2B",
    action : "Tindakan",
    activated : "Aktif",
    active_company : "Perusahaan yang Aktif",
    active_subscription : "Aktifkan Langganan",
    actual_cash_amount : "Jumlah Kas Aktual",
    add : "Tambahkan",
    add_additional_cost : "Tambahkan biaya tambahan",
    add_another_address : "Tambahkan alamat lain",
    add_by_category : "Tambahkan berdasarkan Kategori",
    add_by_supplier : "Tambahkan berdasarkan Pemasok",
    add_categories : "Tambahkan Kategori",
    add_category : "Tambahkan Kategori",
    add_customer : "Tambahkan Pelanggan",
    add_dinning_option : "Tambahkan Opsi Pengiriman Produk",
    add_disassembl : "ambahkan Pembongkara",
    add_disassembly : "Tambahkan Pembongkaran",
    add_discounts : "Tambahkan Diskon",
    add_employee : "Tambahkan Karyawan",
    add_inventory_count : "Tambahkan Perhitungan Inventori",
    add_inventory_counts : "Tambahkan Perhitungan Inventori",
    add_ite : "ambahkan Baran",
    add_item : "Tambahkan Barang",
    add_item_to_jubelio : "Tambahkan Barang dari Jubelio",
    add_items_by_category : "Tambahkan Barang Berdasarkan Kategori",
    add_items_by_supplier : "Tambahkan Barang Berdasarkan Pemasok",
    add_kitchen_printe : "ambahkan Printer Dapu",
    add_kitchen_printer : "Tambahkan Printer Dapur",
    add_men : "ambahkan Men",
    add_menu : "Tambahkan Menu",
    add_modifie : "ambahkan Modifie",
    add_modifier : "Tambahkan Modifier",
    add_modifiers : "Tambahkan Modifiers",
    add_option : "Tambahkan Pilihan",
    add_payment_type : "Tambahkan Jenis Pembayaran",
    add_po : "ambahkan PO",
    add_pos : "Tambahkan POS",
    add_productio : "ambahkan Produks",
    add_production : "Tambahkan Produksi",
    add_purchase_orde : "ambahkan Pesanan Pembelia",
    add_purchase_order : "Tambahkan Pesanan Pembelian",
    add_review : "Tambahkan Ulasan",
    add_rol : "ambahkan Pera",
    add_role : "Tambahkan Peran",
    add_stock : "Penambahan Stok",
    add_stock_adjustmen : "ambahkan Penyesuain Sto",
    add_stock_adjustment : "Tambahkan Penyesuain Stok",
    add_stock_adjustments : "Tambahkan penyesuaian Stok",
    add_stor : "ambahkan Tok",
    add_store : "Tambahkan Toko",
    add_supplie : "ambahkan Pemaso",
    add_supplier : "Tambahkan Pemasok",
    add_ta : "ambahkan Paja",
    add_tax : "Tambahkan Pajak",
    add_time_car : "ambahkan Kartu Wakt",
    add_time_card : "Tambahkan Kartu Waktu",
    add_timecard : "Tambahkan Kartu Waktu",
    add_to_counted : "Tambahkan ke Terhitung",
    add_transfer_orde : "ambahkan Transfer Pesana",
    add_transfer_order : "Tambahkan Transfer Barang",
    add_transfer_orders : "Tambahkan Transfer Barang",
    add_variants : "Tambahkan Varian",
    added_in_to_the_price : "Ditambahkan ke harga",
    additional_cost : "Biaya Tambahan",
    additional_discount : "Diskon Tambahan",
    address : "Alamat",
    address_1 : "Alamat 1",
    address_2 : "Alamat 2",
    address_detail : "Alamat Lengkap",
    address_information : "Informasi Alamat",
    address_label : "Label Alamat",
    address_label_ex : "ex: Rumah, Kantor,...",
    adjust : "Sesuaikan",
    adjust_by : "Disesuaikan oleh",
    adjustment : "Penyesuaian",
    all_day : "Sepanjang Hari",
    all_employees : "Semua Karyawan",
    all_items_will_be_counted : "Semua barang akan dihitung",
    all_order : "Semua Pesanan",
    all_reasons : "Semua Alasan",
    all_receipts : "Semua Resi",
    all_status : "Semua Status",
    all_stock_adjustments : "Semua penyesuaian stok",
    all_store : "Semua Toko",
    all_stores : "Semua Toko",
    all_supplier : "Semua Pemasok",
    allow_to_save_and_edit_orders_before_completing_a_payment : "Izinkan untuk menyimpan dan mengubah pesanan sebelum menyelesaikan pembayaran.",
    already_have_an_account : "Sudah punya akun?",
    amount : "Jumlah",
    amount_discounted : "Jumlah yang Didiskon",
    and : "dan",
    apply : "Terapkan",
    apply_discounts_with_restricted_access : "Terapkan diskon dengan akses terbatas",
    apply_the_tax_to_all_new_and_existing_item : "Terapkan Pajak ke semua item baru & yang sudah ada",
    apply_the_tax_to_the_existing_item : "Terapkan Pajak ke item yang ada",
    apply_the_tax_to_the_new_item : "Terapkan pajak ke item baru",
    apply_to_new_items : "Terapkan Ke Item Baru",
    approve : "Setuju",
    are_you_sure_you_want_to_delete_payment_type : "Jika kamu menghapus metode pembayaran ini, toko kamu tidak akan dapat menerima transaksi online. Apakah kamu ingin menghapusnya?",
    are_you_sure_you_want_to_disable_payment_type: "Jika kamu menonaktifkan metode pembayaran ini, toko kamu tidak akan dapat menerima transaksi online. Apakah kamu ingin menonaktifkannya?",
    are_you_sure_you_want_to_delete_tax : "Anda yakin ingin menghapus pajak?",
    are_you_sure_you_want_to_delete_the_customer : "Anda yakin ingin menghapus pelanggan?",
    are_you_sure_you_want_to_delete_the_employee : "Apakah Anda yakin ingin menghapus karyawan?",
    are_you_sure_you_want_to_delete_the_item : "Anda yakin ingin menghapus barang?",
    are_you_sure_you_want_to_delete_the_review : "Apakah Anda Yakin Ingin Menghapus Ulasan?",
    are_you_sure_you_want_to_delete_the_role : "Anda yakin ingin menghapus peran?",
    are_you_sure_you_want_to_delete_this_address_information : "Anda yakin ingin menghapus informasi alamat ini?",
    are_you_sure_you_want_to_restore_the_item : "Anda yakin ingin memulihkan barang?",
    attachment : "Lampiran",
    available : "Tersedia",
    available_in : "Tersedia dalam",
    available_in_all_stores : "Tersedia di semua toko",
    avaliable_stock : "Stok tersedia",
    average_cost : "Biaya rata-rata",
    average_rating : "Penilaian rata-rata",
    average_sale : "Penjualan Rata-Rata",
    back_office : "Back Office",
    back_office_and_pos : "Back Office and POS",
    back_to : "Kembali ke",
    bar : "Batang",
    barcode : "Barcode",
    billing_and_subscriotion : "Penagihan & Langganan",
    business_entity_type : "Jenis Entitas Bisnis",
    business_name : "Nama Bisnis",
    cancel_btn_text : "Batal",
    card : "KARTU",
    carry_out_purchasing_returns : "Lakukan pengembalian pembelian",
    cash : "UANG TUNAI",
    cash_drawer : "Laci Tunai",
    cash_payments : "Pembayaran Tunai",
    cash_refunds : "Pengembalian Dana Tunai",
    cashier : "Kasir",
    categor : "ategor",
    categories : "Kategori",
    categories_printed_on_this_group : "Kategori yang dicetak pada grup printer ini",
    category : "Kategori",
    category_name : "Nama Kategori",
    category_search : "Pencarian Kategori",
    cc : "Cc",
    change : "Kembalian",
    change_password : "Ubah Kata Sandi",
    change_settings : "Ubah pengaturan",
    change_settings_of_loyalty_program : "Ubah pengaturan program loyalitas",
    change_taxes_in_a_sale : "Mengubah pajak dalam penjualan",
    cheque : "CEK",
    city : "Kabupaten/Kota",
    clock_in : "Jam Masuk",
    clock_in_date : "Tanggal jam masuk",
    clock_in_time : "Waktu jam masuk",
    clock_out : "Jam Keluar",
    clock_out_date : "Tanggal jam keluar",
    clock_out_time : "Waktu jam keluar",
    closed : "Selesai",
    closing_time : "Jam Tutup",
    color_and_shape : "Warna dan Bentuk",
    complete : "Selesai",
    completed : "Selesai",
    component : "Komponen",
    composite_item : "Barang Gabungan",
    confirm : "Konfirmasi",
    confirm_delete_item_message : "Anda yakin ingin menghapus barang ini?",
    confirm_delete_menu_message : "Apakah Anda yakin ingin menghapus Menu? Aplikasi TokoPOS Menu akan dinonaktifkan pada perangkat yang ditetapkan ke Aplikasi Menu ini",
    confirm_delete_pos_message : "Anda yakin ingin menghapus POS? Aplikasi TokoPOS akan dinonaktifkan pada perangkat yang ditetapkan ke POS ini",
    confirm_delete_store_message : "Anda yakin ingin menghapus toko?",
    confirm_password : "Konfirmasi Kata Sandi",
    confirm_release_pos_message : "Apakah Anda yakin ingin melepaskan POS? Aplikasi TokoPOS akan dinonaktifkan pada perangkat yang ditetapkan ke POS ini",
    connect_to_jubelio_account : "Hubungkan ke Akun Jubelio",
    contact_number : "Nomor Kontak",
    corporate : "PERUSAHAAN",
    cost : "Biaya",
    cost_difference : "Selisih Biaya",
    cost_of_good : "Biaya Pokok Barang",
    cost_of_goods : "Biaya Pokok Barang",
    count_item : "Hitung Barang",
    count_stoc : "itung Sto",
    count_stock : "Hitung Stok",
    counted : "Terhitung",
    counted_stock : "Stok yang dihitung",
    country : "Negara",
    create : "Buat",
    create_an_account : "Buat akun",
    create_and_receive : "Buat dan Terima",
    create_category : "Buat Kategori",
    create_customer : "Buat Pelanggan",
    create_discount : "Buat Diskon",
    create_employee : "Buat Karyawan Baru",
    create_your_free_tokoin_account : "Buat akun TokoPOS",
    custome_period : "Periode Kustom",
    customer : "Pelanggan",
    customer_displays : "Tampilan Pelanggan",
    customers : "Pelanggan",
    customers_signed_up : "Pelanggan yang Terdaftar",
    damage : "Kerusakan",
    damaged : "Kerusakan",
    data : "Data",
    date : "Tanggal",
    date_completed : "Tanggal Selesai",
    date_created : "Tanggal Dibuat",
    date_of_transfer_order : "Tanggal Transfer Barang",
    days : "Hari",
    deactivate : "Nonaktifkan",
    decimal_seperator : "Pemisah Desimal",
    default_address : "Alamat default",
    default_dinning_option : "Pilihan Product Delivery Option",
    default : "Default",
    default_location : "Lokasi Default",
    default_purchase_cost : "Biaya Pembelian Default",
    default_so_salesman : "Salesman Default untuk Penjualan",
    default_po_salesman : "Salesman Default untuk Pesanan Pembelian",
    delete_address_information : "Hapus informasi alamat",
    delete_category_message : "Anda yakin ingin menghapus kategori?",
    delete_customer : "Hapus Pelanggan",
    delete_dinning_option : "Hapus Opsi Pengiriman Produk",
    delete_dinning_option_message : "Apakah Anda yakin ingin menghapus opsi pengiriman produk?",
    delete_discount : "Hapus Diskon",
    delete_discount_message : "Anda yakin ingin menghapus diskon?",
    delete_employee : "Hapus Karyawan",
    delete_item : "Hapus Barang",
    delete_kitchen_printer : "Hapus Printer Dapur",
    delete_kitchen_printer_message : "Anda yakin ingin menghapus printer dapur?",
    delete_kitchen_printers_message : "Anda yakin ingin menghapus printer dapur?",
    delete_menu : "Hapus Menu",
    delete_modifier : "Hapus Modifier",
    delete_modifier_message : "Anda yakin ingin menghapus modifier?",
    delete_multiple_customers_message : "Anda yakin ingin menghapus pelanggan yang dipilih?",
    delete_multiple_employee_message : "Anda yakin ingin menghapus karyawan yang dipilih?",
    delete_multiple_items_message : "Anda yakin ingin menghapus barang yang dipilih?",
    delete_multiple_payment_types_message : "Anda yakin ingin menghapus jenis pembayaran?",
    delete_multiple_taxes_message : "Anda yakin ingin menghapus pajak yang dipilih?",
    delete_payment_type : "Hapus Jenis Pembayaran",
    delete_pos : "Hapus POS",
    delete_role : "Hapus Peran",
    delete_saved_items_in_open_tickets : "Hapus item yang disimpan dalam tiket terbuka",
    delete_store : "Hapus Toko",
    delete_suppiler : "Hapus Pemasok",
    delete_suppiler_confirm : "Apakah Anda yakin ingin menghapus pemasok ini?",
    delete_tax : "Hapus Pajak",
    deleted_successfully : "Berhasil dihapus!",
    description : "Deskripsi",
    destination_stock : "Stok Tujuan",
    destination_store : "Toko Tujuan",
    difference : "Selisih",
    dinning_option : "Pilihan Makanan",
    dinning_options : "Opsi Pengiriman Produk",
    dinning_options_store : "Opsi Pengiriman Produk - Toko",
    disassembly : "Pembongkaran",
    disassembly_detail : "etail Pembongkara",
    disassembly_details : "Detail Pembongkaran",
    discoun : "isko",
    discount : "Diskon",
    discount_applied : "Diskon Berlaku",
    discounts : "Diskon",
    display_order_information_to_customers_at_the_time_of_purchase : "Menampilkan informasi pesanan kepada pelanggan pada saat pembelian.",
    district : "Kecamatan",
    dont_have_an_account_to_tokoin : "Belum punya akun di TokoPOS?",
    draft : "Draf",
    due_amount : "Jumlah Terutang",
    duplicated_item_name : "Nama Barang Duplikat",
    duplicated_customer_data : "Duplikasi Data Pelanggan",
    each : "Satuan",
    edit : "Ubah",
    edit_account_information : "Ubah Informasi Akun",
    edit_dinning_optio : "dit Pilihan Makana",
    edit_dinning_option : "Edit Opsi Pengiriman Produk",
    edit_disassembl : "dit Pembongkara",
    edit_disassembly : "Edit Pembongkaran",
    edit_inventory_count : "Edit Perhitungan Inventori",
    edit_inventory_counts : "Edit Perhitungan Inventori",
    edit_ite : "dit Baran",
    edit_item : "Edit barang",
    edit_items : "Kelola barang, kategori, dan diskon",
    edit_items_and_manage_inventory : "Ubah Barang dan Kelola Inventori",
    edit_kitchen_printe : "dit Printer Dapu",
    edit_kitchen_printer : "Edit Printer Dapur",
    edit_men : "dit Men",
    edit_menu : "Edit Menu",
    edit_modifie : "dit Modifie",
    edit_modifier : "Edit Modifier",
    edit_po : "dit PO",
    edit_pos : "Edit POS",
    edit_productio : "dit Produks",
    edit_production : "Edit Produksi",
    edit_profile : "Kelola Pengaturan Umum dan Fitur",
    edit_purchase_orde : "dit Pesanan Pembelia",
    edit_purchase_order : "Edit Pesanan Pembelian",
    edit_rol : "dit Pera",
    edit_role : "Edit Peran",
    edit_stock_adjustmen : "dit Penyesuaian Sto",
    edit_stock_adjustment : "Edit Penyesuaian Stok",
    edit_stor : "dit Tok",
    edit_store : "Edit Toko",
    edit_supplie : "dit Pemaso",
    edit_supplier : "Edit Pemasok",
    edit_ta : "dit Paja",
    edit_tax : "Edit Pajak",
    edit_time_car : "dit Kartu Wakt",
    edit_time_card : "Edit Kartu Waktu",
    edit_transfer_orde : "dit Transfer Pesana",
    edit_transfer_order : "Edit Transfer Barang",
    email : "Email",
    emailed_receipt : "Logo pada Resi Email",
    employee : "Karyawan",
    employee_list : "Daftar Karyawan",
    employee_name : "Nama Karyawan",
    employees : "Karyawan",
    employees_can_log_in_to_the_app_using_personal_pin_code : "Karyawan dapat masuk ke aplikasi menggunakan kode PIN pribadi",
    employees_can_log_in_to_the_back_office_using_their_email_and_password : "Karyawan dapat masuk ke Back Office menggunakan email dan kata sandi",
    employees_can_log_in_to_the_menu_app_using_their_email_and_password : "Karyawan dapat masuk ke aplikasi Menu menggunakan email dan kata sandi mereka",
    end_date : "Tanggal Berakhir",
    end_time : "Jam Keluar",
    english : "Inggris",
    error : "Kesalahan",
    existed_sku : "SKU Sudah Ada",
    expected_arrival_date : "Perkiraan Tanggal Kedatangan",
    expected_arrival_on : "Tanggal Kedatangan yang Diharapkan",
    expected_cash_amount : "Jumlah Kas yang Diharapkan",
    expected_on : "Diharapkan Pada",
    expected_stock : "Stok yang Diharapkan",
    export : "Ekspor",
    export_receipt : "Ekspor resi",
    export_purchase_order: "Export Purchase Order",
    export_transaction : "Ekspor semua transaksi",
    features : "Fitur",
    first : "Pertama",
    first_visit : "Kunjungan Pertama",
    fix : "Tetap",
    footer : "Footer pada Resi Email",
    forgot_password : "Lupa Kata Sandi?",
    french : "Perancis",
    from : "Dari",
    full : "Penuh",
    general : "Umum",
    general_settings : "Pengaturan Umum",
    get_daily_email_on_items_that_are_low_or_out_of_stock : "Dapatkan email harian tentang barang dengan stok rendah atau kehabisan stok.",
    gross_profit : "Laba Kotor",
    gross_sale : "Penjualan Kotor",
    gross_sales : "Penjualan Kotor",
    header : "Header pada Resi Email",
    hello_world : "Halo Dunia!",
    history : "Riwayat",
    hours : "Jam",
    i_understand_and_agree_to_tokoin : "Saya Mengerti dan Menyetujui TokoPOS",
    image : "Gambar",
    import : "Impor",
    in_progress : "Dalam Proses",
    in_stock : "Dalam Stok",
    included_in_the_price : "Termasuk dalam harga",
    incoming : "Masuk",
    inventory : "Inventori",
    inventory_count : "Perhitungan Inventori",
    inventory_count_detail : "Detail Perhitungan Inventori",
    inventory_count_details : "Detail Perhitungan Inventori",
    inventory_counts : "Perhitungan Inventori",
    inventory_history : "Riwayat Inventori",
    inventory_management : "Manajemen Inventori",
    inventory_valuation : "Valuasi Inventori",
    inventory_value : "Nilai Inventori",
    it_is_a_shortcut_to_input_how_much_your_customer_pay_by_cash : "Ini merupakan cara untuk memasukkan berapa banyak uang tunai yang dibayarkan oleh pelanggan Anda.",
    item : "Barang",
    item_add : "Barang Tambahan",
    item_added : "Item Telah Ditambahkan",
    item_bundle : "Barang Bundle",
    item_list : "Daftar Barang",
    item_name : "Nama Barang",
    item_refunded : "Barang Dikembalikan",
    item_search : "Pencarian Barang",
    item_sold : "Barang Terjual",
    items : "Barang",
    items_and_inventory_management : "Manajemen Barang dan Inventori",
    items_refunded : "Barang Dikembalikan",
    jubelio_account : "Akun Jubelio",
    jubelio_integration : "Integrasi Jubelio",
    jubelio_sale_id : "Jubelio Sale Id",
    jubelio_sale_name : "Jubelio Sale name",
    kitchen_printers : "Printer Dapur",
    last : "Terakhir",
    last_login : "Masuk terakhir",
    last_month : "Bulan lalu",
    last_visit : "Kunjungan Terakhir",
    last_week : "Minggu lalu",
    latitude : "Garis lintang",
    learn_more : "Pelajari Lebih Lanjut",
    leave_the_field_blank_to_indicate_the_price_for_sale : "Biarkan kolom kosong untuk menunjukkan harga saat dijual",
    leave_the_field_blank_to_indicate_the_value_upon_sale : "Biarkan kolom kosong untuk menunjukkan nilai saat dijual",
    line : "Garis",
    login : "Masuk",
    logout : "Keluar",
    longitude : "Garis bujur",
    looks_like_something_went_wrong : "Sepertinya ada yang tidak beres!",
    loss : "Kehilangan",
    lost : "Kehilangan",
    low_stock : "Batas Rendah Stok",
    low_stock_level : "Tingkat stok rendah",
    low_stock_notification : "Pemberitahuan Stok Rendah",
    make_this_address_default : "Jadikan alamat ini utama",
    manage_all_open_tickets : "Kelola semua tiket terbuka",
    manage_billing : "Kelola penagihan",
    manage_dining_options : "Kelola Opsi Pengiriman Produk",
    manage_employees : "Kelola karyawan",
    manage_pos_devices : "Kelola Perangkat POS",
    manage_subscription : "Kelola Langganan",
    margin : "Margin",
    mark_all_received : "Tandai semua sebagai Diterima",
    mark_orders_as_dine_in_takeout_or_for_delivery : "Tandai pesanan sebagai makan di tempat, bawa pulang atau untuk pengiriman.",
    max_value : "Nilai Maks",
    menu : "Menu",
    menu_app : "Aplikasi Menu",
    menu_devices : "Perangkat Menu",
    message : "Pesan",
    mobile_number : "Nomor Handphone",
    modifie : "odifie",
    modifier : "Modifier",
    modifier_name : "Nama Modifier",
    modifiers : "Modifier",
    money_shortcut : "Pintasan Uang",
    month : "Bulan",
    name : "Nama",
    negative_stock_alerts : "Peringatan Stok Negatif",
    net_amount : "Jumlah Bersih",
    net_sale : "Penjualan Bersih",
    net_sales : "Penjualan Bersih",
    new_password : "Kata Sandi Baru",
    next : "Selanjutnya",
    no : "Tidak",
    no_account_yet : "Belum ada acccount",
    no_category : "Tidak Ada Kategori",
    no_category_found : "Kategori Tidak Ditemukan",
    no_customer_found : "Pelanggan Tidak Ditemukan",
    no_customers_found : "Pelanggan Tidak Ditemukan",
    no_dinning_option_found : "Opsi Pengiriman Produk Tidak Ditemukan",
    no_discount_found : "Diskon Tidak Ditemukan",
    no_employee_found : "Karyawan Tidak Ditemukan",
    no_items_found : "Item Tidak Ditemukan",
    no_kitchen_printer_found : "Tidak Ada Printer Dapur yang Ditemukan",
    no_menu_devices_found : "Tidak Ada Perangkat Menu yang Ditemukan",
    no_modifier_found : "Tidak Ada Modifier Yang Ditemukan",
    no_paymen_type_found : "Jenis Pembayaran Tidak Ditemukan",
    no_pos_devices_found : "Tidak Ada POS yang Ditemukan",
    no_receipt_found : "Resi Tidak Ditemukan",
    no_record_found : "Catatan Tidak Ditemukan",
    no_reviews_found : "Ulasan Tidak Ditemukan",
    no_roles_found : "Tidak Ada Peran Yang Ditemukan",
    no_shift_found : "Shift Tidak Ditemukan",
    no_stores_found : "Tidak Ada Toko yang Ditemukan",
    no_supplier_found : "Pemasok Tidak Ditemukan",
    no_tax_found : "Tidak Ada Pajak yang Ditemukan",
    no_taxes_found : "Tidak Ada Pajak yang Ditemukan",
    no_timecard_found : "Kartu Waktu Tidak Ditemukan",
    no_transfer_orders_found : "Transfer Barang Tidak Ditemukan",
    non_taxable_sales : "Penjualan Tidak Kena Pajak",
    none : "Tidak ada",
    not_activated : "Tidak aktif",
    note : "Catatan",
    notes : "Catatan",
    number_of_pos : "Jumlah POS",
    of : "dari",
    old_password : "Kata Sandi Lama",
    only_employees_with_appropriate_access_right_are_able_to_apply_this_discount : "Hanya karyawan dengan hak akses yang sesuai yang dapat menerapkan diskon ini",
    open_cash_drawer_without_making_a_sale : "Buka laci tunai tanpa membuat penjualan",
    open_tickets : "Buka Tiket",
    opening_time : "Jam Buka",
    optimal_stock : "Stok Optimal",
    option : "Pilihan",
    option_name : "Nama opsi",
    ordered : "Dipesan",
    ordered_by : "Dipesan Oleh",
    other : "LAINNYA",
    out_stock : "Stok Habis",
    owner : "Pemilik",
    paid_in : "Dibayar",
    paid_out : "Terbayar",
    partial : "Parsial",
    password : "Kata Sandi",
    payment : "PEMBAYARAN",
    payment_amount : "Jumlah Pembayaran",
    payment_transactions : "Transaksi Pembayaran",
    payment_type : "Jenis Pembayaran",
    payment_types : "Tipe Pembayaran",
    pending : "Tertunda",
    percentage : "Persentase",
    period : "Periode",
    personal : "PRIBADI",
    phone : "Telepon",
    phone_number : "Nomor Telepon",
    pie : "Pie",
    please_agree_to_tokoin_terms : "Harap Setuju dengan Syarat Penggunaan dan Kebijakan Privasi TokoPOS",
    please_enter_10_digits_mobile_number : "Silakan masukkan minimal 7 digit nomor ponsel",
    please_enter_10_digits_phone_number : "Silakan masukkan minimal 7 digit nomor telepon",
    please_enter_10_digits_hand_phone: "Silakan masukkan minimal 7 digit nomor handphone",
    please_enter_4_digits_pos_pin : "Masukkan 4 digit PIN POS",
    please_enter_address : "Silakan masukkan alamat",
    please_enter_address_1 : "Silakan pilih Address1",
    please_enter_address_2 : "Silakan pilih Address2",
    please_enter_business_name : "Harap Masukkan Nama Bisnis Anda",
    please_enter_confirm_password : "Silahkan konfirmasi kata sandi baru",
    please_enter_contact_number : "Silakan masukkan nomor kontak yang valid",
    please_enter_default_purchase_cost : "Silakan masukkan biaya yang valid",
    please_enter_email : "Harap Masukkan Email yang Valid",
    please_enter_footer : "Silakan Masukkan Footer",
    please_enter_header : "Silakan Masukkan Header",
    please_enter_latitude : "Silakan masukkan Garis lintang",
    please_enter_longitude : "Silakan masukkan Garis bujur",
    please_enter_mobile_number : "Silakan masukkan nomor ponsel yang valid",
    please_enter_handphone_number: "Silakan masukkan nomor handphone yang valid",
    please_enter_name : "Silakan Masukkan Nama",
    please_enter_new_password : "Silahkan masukkan kata sandi baru",
    please_enter_old_password : "Silahkan masukkan kata sandi lama",
    please_enter_option_name : "Silakan masukkan nama pilihan",
    please_enter_password : "Silakan Masukkan Kata Sandi",
    please_enter_phone_number : "Silakan masukkan nomor telepon yang valid",
    please_enter_quantity : "Silakan masukkan kuantitas",
    please_enter_region : "Silakan masukkan wilayah",
    please_enter_sku : "Silakan masukkan SKU",
    please_enter_supplier_name : "Silakan masukkan nama Pemasok",
    please_enter_title : "Silakan masukkan judul",
    please_enter_unique_option_name : "Silakan masukkan nama pilihan yang unik",
    please_enter_valid_available_stock : "Silakan masukkan stok yang tersedia",
    please_enter_valid_average_cost : "Silakan masukkan biaya rata-rata yang valid",
    please_enter_valid_cost : "Silakan masukkan biaya yang valid",
    please_enter_valid_counted_stock : "Silakan masukkan stok terhitung yang valid",
    please_enter_valid_email : "Silakan masukkan email yang valid",
    please_enter_valid_name : "Silakan masukkan nama yang valid",
    please_enter_valid_price : "Silakan masukkan harga yang valid",
    please_enter_valid_quantity : "Silakan masukkan jumlah yang valid",
    only_in_stock: "Hanya tersedia QUANTITY dalam stok",
    this_item_is_out_of_stock: "Stok barang ini habis",
    please_enter_valid_remove_stock : "Silakan masukkan stok dihapus yang valid",
    please_enter_valid_stock : " Silakan masukkan stok yang valid",
    please_enter_valid_tax_rate : "Silakan Masukkan Tarif Yang Valid",
    please_enter_valid_value : "Silakan masukkan nilai yang valid",
    please_enter_website : "Harap masukkan situs web yang valid",
    please_enter_zip_code : "Silakan masukkan kode pos yang valid",
    please_login_to_your_jubelio_account : "Silakan masuk ke akun jubelio",
    please_select_atleast_one_item : "Silakan pilih setidaknya satu barang",
    please_select_business_type : "Silakan Pilih Jenis Bisnis Anda",
    please_select_category : "Silakan pilih kategori",
    please_select_clock_in_date : "Silakan pilih tanggal jam masuk",
    please_select_clock_in_time : "Silakan pilih waktu jam masuk",
    please_select_clock_out_date : "Silakan pilih tanggal jam keluar",
    please_select_clock_out_time : "Silakan pilih waktu jam keluar",
    please_select_country : "Silakan Pilih Negara",
    please_select_decimal_separator : "Silakan pilih pemisah desimal",
    please_select_destination_store : "Silakan Pilih Toko Tujuan",
    please_select_employee : "Silakan pilih karyawan",
    please_select_image : "Silakan pilih gambar",
    please_select_item : "Silakan pilih barang",
    please_select_option : "Silakan pilih opsi",
    please_select_payment_type : "Silakan Pilih Jenis Pembayaran",
    please_select_payment_name : "Please Select Payment Name",
    please_select_purchase_date : "Silahkan pilih tanggal pembelian",
    please_select_reason : "Silakan pilih alasan",
    please_select_receipt_language : "Silakan Pilih Bahasa Resi",
    please_select_role : "Silahkan pilih peran",
    please_select_source_store : "Silakan Pilih Toko Sumber",
    please_select_store : "Silakan Pilih Toko",
    please_select_supplier : "Silakan pilih Pemasok",
    please_select_title: "Please select title",
    please_select_timezone : "Silakan Pilih Zona Waktu",
    please_select_transfer_date : "Silakan pilih tanggal transfer",
    please_select_type : "Silakan pilih jenis",
    please_select_ui_langugae : "Harap Pilih Bahasa UI",
    pos : "POS",
    pos_devices : "Perangkat POS",
    pos_pin : "PIN POS",
    postal_or_zip_code : "Kode Pos",
    potential_profit : "Potensi Keuntungan",
    previous : "Sebelumnya",
    price : "Harga",
    primary_supplier : "Pemasok Utama",
    print : "Cetak",
    printed_receipt : "Logo pada Resi Cetak",
    privacy_policy : "Kebijakan Privasi",
    product_name : "Nama Produk",
    productio : "roduks",
    production : "Produksi",
    production_count : "Perhitungan Produksi",
    production_detail : "etail Produks",
    production_details : "Detail Produksi",
    productions : "Produksi",
    profil : "rofi",
    profile : "Profil",
    province : "Provinsi",
    puchase_order : "Pesanan Pembelian",
    purchase_cost : "Biaya Pembelian",
    purchase_date : "Tanggal Pembelian",
    purchase_orde : "esanan Pembelia",
    purchase_order : "Pesanan Pembelian",
    purchase_order_date : "Tanggal Pesanan Pembelian",
    purchase_order_detail : "etail Pesanan Pembelia",
    purchase_order_details : "Detail Pesanan Pembelian",
    purchase_orders : "Pesanan Pembelian",
    qty : "Qty",
    quantity : "Kuantitas",
    quantity_refunded : "Kuantitas dikembalikan",
    quantity_sold : "Kuantitas terjual",
    quarter : "Kuartal",
    rate : "Nilai",
    rating_review : "Penilaian & Ulasan",
    reason : "Alasan",
    receip : "es",
    receipt : "Resi",
    receipt_language : "Bahasa Resi",
    receipt_no : "No. Resi",
    receipt_setting : "Pengaturan Resi",
    receipts : "Resi",
    receive : "Terima",
    receive_purchase_orde : "erima Pesanan Pembelia",
    receive_purchase_order : "Terima Pesanan Pembelian",
    received : "Diterima",
    received_item : "Barang yang Diterima",
    recently_deleted_item : "arang yang Baru Dihapu",
    recently_deleted_items : "Barang yang Baru Dihapus",
    recieved : "Diterima",
    recounted : "Perhitungan Ulang",
    refund : "Pengembalian Dana",
    refund_amount : "Jumlah Pengembalian Dana",
    refund_transactions : "Transaksi Pengembalian Dana",
    refunds : "Pengembalian Dana",
    region_state_province : "Wilayah / Negara Bagian / Provinsi",
    register : "Daftar",
    registration : "Registrasi",
    related_to : "Terkait dengan",
    release_pos : "Rilis POS",
    remember_me : "Ingat Saya",
    remove_stock : "Pengurangan Stok",
    report : "Melaporkan",
    reports : "Laporan",
    representation_on_pos : "Representasi pada POS",
    restaurants : "Restoran",
    restore : "Pulihkan",
    restore_item : "Pulihkan Barang",
    restore_multiple_items_message : "Anda yakin ingin memulihkan item yang dipilih?",
    restored_successfully : "Berhasil Dipulihkan!",
    restricted_access : "Pembatasan Akses",
    retail : "Ritel",
    retail_value : "Nilai Ritel",
    return : "Pengembalian",
    revie : "lasa",
    review : "Ulasan",
    review_date : "Tanggal Ulasan",
    review_rating : "Ulasan & Penilaian",
    role : "Peran",
    rows_per_page : "Baris per halaman",
    sales : "Penjualan",
    sales_by_categor : "enjualan Berdasarkan Kategor",
    sales_by_category : "Penjualan Berdasarkan Kategori",
    sales_by_employe : "enjualan Berdasarkan Karyawa",
    sales_by_employee : "Penjualan Berdasarkan Karyawan",
    sales_by_ite : "enjualan Berdasarkan Baran",
    sales_by_item : "Penjualan Berdasarkan Barang",
    sales_by_item_chart : "Penjualan Berdasarkan Grafik Barang",
    sales_by_modifie : "enjualan Berdasarkan Modifie",
    sales_by_modifier : "Penjualan Berdasarkan Modifier",
    sales_by_payment_typ : "enjualan Berdasarkan Tipe Pembayara",
    sales_by_payment_type : "Penjualan Berdasarkan Jenis Pembayaran",
    sales_summar : "ingkasan Penjuala",
    sales_summary : "Ringkasan Penjualan",
    save : "Simpan",
    save_and_count : "Simpan dan Hitung",
    save_and_receive : "Simpan dan Terima",
    save_as_draft : "Simpan sebagai Draf",
    save_btn_text : "Simpan",
    search_enter : "Cari & Enter",
    search_product_name_or_sku : "Cari Nama Produk atau SKU",
    select : "Pilih",
    select_additional_costs_to_apply_to_this_receipt : "Pilih biaya tambahan untuk diterapkan ke resi ini",
    select_category : "Pilih Kategori",
    select_city : "Pilih Kabupaten/Kota",
    select_country : "Pilih Negara",
    select_destination_store : "Pilih Toko Tujuan",
    select_district : "Pilih Kecamatan",
    select_employee : "Pilih Karyawan",
    select_province : "Pilih Provinsi",
    select_role : "Pilih Peran",
    select_source_store : "Pilih Toko Sumber",
    select_status : "Pilih Status",
    select_store : "Pilih Toko",
    select_supplier : "Pilih Pemasok",
    select_village : "Pilih Kelurahan",
    send : "Kirim",
    send_employee_invitation_email : "Kirim email undangan",
    send_orders_to_kitchen_printer_or_display : "Kirim pesanan ke printer dapur atau layar.",
    send_purchase_order_by_email : "Mengirim pesanan pembelian melalui email",
    send_receipt : "Kirim Resi",
    send_set_password_link_to_employee_email : "Kirim tautan atur kata sandi ke email karyawan?",
    set_pin : "ATUR PIN",
    set_the_kitchen_printers : "Atur printer dapur",
    set_the_payment_types : "Kelola Tipe Pembayaran",
    set_the_taxes : "Atur Pajak",
    setting : "Pengaturan",
    settings : "Pengaturan",
    shift : "hif",
    shift_closed : "Shift Ditutup",
    shift_opened : "Shift Dibuka",
    shift_report : "Laporan Shift",
    shifts : "Shift",
    show_comments : "Tampilkan Komentar",
    show_customer_info : "Tampilkan Info Pelanggan",
    sign_in : "Masuk",
    sign_in_to_your_tokoin_account : "Masuk ke akun TokoPOS Anda",
    similar_item_name_already_exists : "Nama barang serupa sudah ada. Apakah Anda ingin melanjutkan?",
    sku : "SKU",
    sku_and_barcode : "SKU and barcode",
    sku_cannot_be_found : "SKU item_name tidak dapat ditemukan",
    sold : "Terjual",
    sold_by : "Dijual berdasarkan",
    source_stock : "Stok Sumber",
    source_store : "Toko Sumber",
    start_time : "Jam Masuk",
    starting_cash : "Uang Tunai Awal",
    status : "Status",
    stock_adjustmen : "enyesuaian Sto",
    stock_adjustment : "Penyesuaian Stok",
    stock_adjustment_detail : "etail Penyesuain Sto",
    stock_adjustment_details : "Detail Penyesuain Stok",
    stock_adjustments : "Penyesuaian Stok",
    stock_after : "Stok Sesudah",
    stock_alert : "Peringatan Stok",
    stock_before : "Stok Sebelum",
    store : "Toko",
    store_and_pos_settings : "Pengaturan Toko & POS",
    store_lowercase : "toko",
    stores : "Toko",
    subject : "Subjek",
    submit : "Kirim",
    subscribe : "Berlangganan",
    subscription : "Langganan",
    subtotal : "Subtotal",
    sum : "Jumlah",
    supplier : "Pemasok",
    supplier_name : "Nama Pemasok",
    supplier_search : "Pencarian Pemasok",
    suppliers : "Pemasok",
    support : "Dukungan",
    sync_all_sales_to_jubelio : "Sinkronkan semua Penjualan dan Pesanan Pembelian dari TokoPOS ke Jubelio",
    sync_status : "Status Sync",
    system_settings : "Pengaturan Sistem",
    tax_amount : "Jumlah Pajak",
    tax_application_depends_on_dining_option : "Penerapan pajak tergantung pada pilihan makanan",
    tax_name : "Nama Pajak",
    tax_rate : "Tarif Pajak",
    taxable_sales : "Penjualan Kena Pajak",
    taxe : "aja",
    taxes : "Pajak",
    terms_of_use : "Syarat Penggunaan",
    the_item_is_available_for_now : "Barang ini tersedia untuk saat ini",
    this_month : "Bulan ini",
    this_permission_also_allows_to_sign_into_pos_using_email_and_password : "Izin ini juga memungkinkan masuk ke POS menggunakan email dan kata sandi",
    this_year : "Tahun ini",
    time_car : "artu Wakt",
    time_card : "Kartu Waktu",
    time_clock : "Jam Waktu",
    timecards : "Kartu Waktu",
    timezone : "Zona Waktu",
    title : "Judul",
    to : "Ke",
    to_receive : "Akan Menerima",
    today : "Hari ini",
    total : "Jumlah",
    total_amount : "#   Total Penjualan",
    total_hours : "Jumlah Jam",
    total_hours_worked : "Total Jam Kerja",
    total_inventory_value : "Total Nilai Inventori",
    total_net_sales : "Total Penjualan Bersih",
    total_retail_value : "Total Nilai Ritel",
    total_spent : "Total yang Dibelanjakan",
    total_tendered : "Total Ditenderkan",
    total_visits : "Jumlah Kunjungan",
    track_crash_that_goes_in_and_out_of_your_drawer : "Lacak uang masuk dan keluar dari laci Anda.",
    track_employees_clock_in_out_time_and_calculate_their_total_work_hours : "Lacak jam masuk/keluar karyawan dan hitung total jam kerja mereka.",
    track_stock : "Lacak stok",
    transfer : "Transfer",
    transfer_orde : "ransfer Pesana",
    transfer_order : "Transfer Barang",
    transfer_order_detail : "Detail Transfer Barang",
    transfer_order_details : "Detail Transfer Barang",
    transfer_orders : "Transfer Barang",
    transferred : "Ditransfer",
    type : "Tipe",
    type_to_search_here : "Ketik untuk pencarian di sini",
    ui_language : "Bahasa UI",
    unable_to_synchronize_to_jubelio : "Tidak dapat menyinkronkan ke Jubelio",
    unsubscribe : "Hentikan Langganan",
    update_bank : "Perbarui Ulasan",
    update_category : "Perbarui Kategori",
    update_customer : "Perbarui Pelanggan",
    update_discount : "Perbarui Diskon",
    update_employee : "Perbarui Karyawan",
    upload : "Unggah",
    upload_image : "Unggah Gambar",
    upload_profile : "Unggah Profil",
    use_predefined_tickets : "Menggunakan tiket yang telah ditentukan sebelumnya",
    use_predefined_tickets_text : "Fitur ini memungkinkan Anda menetapkan nama dengan cepat untuk membuka tiket. Misalnya, Tabel 1, Tabel 2, dll.",
    use_production : "Gunakan Produksi",
    use_variants_suggestion_messge : "Gunakan varian jika item memiliki ukuran, warna, atau opsi lainnya yang berbeda",
    value : "Nilai",
    variable : "variabel",
    variant : "Varian",
    variants : "Varian",
    view_account_information : "Lihat Informasi Akun",
    view_all_receipts : "Lihat semua resi",
    view_sales_reports : "Lihat laporan penjualan",
    view_shift_report : "Lihat laporan shift",
    village : "Kelurahan",
    waiting_for_employee_to_log_in : "Menunggu karyawan untuk masuk",
    warn_cashiers_attempting_to_sell_more_inventory_than_available_in_stock : "Peringatkan kasir yang mencoba menjual lebih banyak Inventori daripada yang tersedia di stok.",
    website : "Situs web",
    week : "Minggu",
    weight : "Berat",
    when_adding_employees_the_authentication_by_PIN_code_mode_is_enabled_Set_your_own_PIN_to_enter_Tokoin_POS_application : "Saat menambahkan karyawan otentikasi dengan mode kode PIN diaktifkan. Atur PIN Anda sendiri untuk masuk ke aplikasi TokoPOS.",
    when_this_option_is_disabled_a_cashier_can_view_the_last_5_receipts : "Bila opsi ini dinonaktifkan, kasir dapat melihat 5 resi terakhir",
    write_here_something : "Tulis sesuatu di sini",
    year : "Tahun",
    yes : "Ya",
    yesterday : "Kemarin",
    your_free_trial_expires_in : "Uji coba gratis Anda berakhir di",
    list_is_empty: "Daftar kosong",
    delete_category: "Hapus Kategori",
    delete_timecard: "Hapus Kartu Waktu",
    confirm_delete_timecard: "Apakan Anda yakin ingin menghapus kartu waktu?",
    minutes: "menit",
    please_enter_to_select: "Tekan enter untuk memilih",
    please_enter_to_remove: "Tekan enter untuk menghapus",
    expected_date_must_not_earlier_than_purchase_date: "Perkiraan Tanggal Kedatangan tidak boleh lebih cepat dari Tanggal Pembelian",
    must_not_earlier_than_clock_time: "Jam Keluar tidak boleh lebih cepat dari Jam Masuk",
    unable_to_sync: "Tidak dapat menyinkronkan",
    you_do_not_have_access_to_menu: "Anda tidak memiliki akses untuk menu ini",
    the_owner_must_signin_to_the_jubelio: "Pemilik harus memasukkan akun Jubelio sebelum Anda dapat mengakses menu ini",
    shipping_address: "Alamat Pengiriman",
    product_delivery_option: "Opsi Pengiriman Produk",
    enable_b2b: "B2B",
    enable_b2b_desc: "Aktifkan pembelian barang dari toko lain di bawah akun bisnis ini.",
    enable_b2b_buying: "Aktifkan Pembelian B2B",
    b2b_price: "Harga B2B",
    assigned_to_n_store: "Ditugaskan pada n_store toko",
    assigned_to_all_stores: "Ditugaskan pada semua toko",
    assigned_to: "Ditugaskan pada",
    customer_assigned_to: "Diakses pada",
    customer_assigned_to_all_stores: "Diakses pada semua toko",
    search_store: "Cari toko",
    select_all_stores: "Pilih semua toko",
    search_variant: "Cari varian",
    select_all_variants: "Pilih semua varian",
    search_store_or_variant_added: "Cari toko atau varian yang ditambahkan",
    for_stores_that_not_enabled_b2b_buying: "Untuk toko yang TIDAK mengaktifkan Pembelian B2B, hanya Penjualan yang akan disinkronkan",
    for_stores_that_enabled_b2b_buying: "Untuk toko yang mengaktifkan Pembelian B2B, hanya Pesanan Pembelian yang akan disinkronkan",
    delivery_fee: "Ongkos Kirim",
    insurance: "Asuransi",
    other_cost: "Biaya Lainnya",
    filter_by: "Filter berdasarkan",
    manage_transfer_order: "Kelola Transfer Barang",
    manage_stores: "Kelola Toko",
    access_rights: "Hak Akses",
    manage_roles: "Kelola peran",
    no_results_found: "Hasil pencarian tidak ditemukan",
    create_items: "Tambah Barang",
    manage_items_inventory: "Kelola Barang dan Inventori",
    update: "Update",
    receive_transfer_order: "Terima Transfer Barang",
    are_you_sure_you_want_to_receive_all_items: "Apakah Anda yakin ingin menerima semua barang?",
    send_transfer_order_by_email: "Mengirim email transfer barang",
    please_select_state: "Silahkan pilih provinsi",
    please_select_district: "Silahkan pilih kecamatan",
    please_select_city: "Silahkan pilih kabupaten/kota",
    please_select_village: "Silahkan pilih kelurahan",
    account_information: "Informasi Akun",
    business_information: "Informasi Bisnis",
    business_type: "Tipe Bisnis",
    select_business_type: "Pilih Tipe Bisnis",
    sub_business_type: "Subtipe Bisnis",
    select_sub_business_type: "Pilih Subtipe Bisnis",
    personal_information: "Informasi Pribadi",
    id_card_number: "Nomor Kartu Identitas (KTP)",
    name_on_id_card: "Nama sesuai KTP",
    date_of_birth: "Tanggal Lahir",
    id_card: "KTP",
    selfie_with_id_card: "Foto dengan KTP",
    bank_information: "Informasi Bank",
    bank_name: "Nama Bank",
    account_holder_name: "Nama Pemilik Akun",
    account_number: "Nomor Akun",
    country_language_chosen: "Negara & Pilihan Bahasa",
    language: "Bahasa",
    destination_store_can_not_be_the_same_as_source_store: "Toko Tujuan tidak boleh sama dengan Toko Sumber",
    gender: "Jenis Kelamin",
    male: "Laki-Laki",
    female: "Perempuan",
    business_resources: "Sumber Daya Bisnis",
    go: "Buka",
    fillter_tags: "Filter Tag",
    selected: "Dipilih",
    press_enter_to_create_new_tag: "Tekan enter untuk menambahkan",
    customer_sharing: "Berbagi Data Pelanggan",
    customer_sharing_desc: "Izinkan berbagi data pelanggan antar toko dalam akun bisnis ini.",
    this_customer_is_not_assigned_to_any_store: "Pelanggan ini tidak dapat diakses di toko manapun. Apakah Anda ingin melanjutan?",
    no_orders_found: "Pesanan Tidak Ditemukan",
    no_stock_adjustment_found: "Penyesuaian Stok Tidak Ditemukan",
    no_inventory_count_found: "Perhitungan Inventori Tidak Ditemukan",
    no_inventory_valuation_found: "Valuasi Inventori Tidak Ditemukan",
    no_inventory_history_found: "Riwayat Inventori Tidak Ditemukan",
    account_need_verify_to_do_action: "Akun Anda masih dalam proses verifikasi oleh tim kami. Anda baru dapat melakukan tindakan ini setelah status akun terverifikasi.",
    duplicated_category: "Duplikasi Kategori",
    image_ratio_1_3_validator: "Silahkan mengunggah gambar dengan rasio 3:1",
    whats_app_number: "Nomor WhatsApp",
    whats_app_desc: "Nomor ini akan digunakan pada tombol chat WhatsApp untuk katalog etalase toko online Anda.",
    working_hours_information: "Informasi Jam Kerja",
    working_hours_holder: "Contoh: Senin: 09.00 - 18.00",
    delivery_information: "Informasi Pengiriman",
    delivery_holder: "Contoh: Kami akan mengirim pesanan Anda 1 hari setelah pembayaran kami terima.",
    payment_information: "Informasi Pembayaran",
    payment_holder: "Contoh: Admin kami akan mengontak Anda melalui WhatsApp untuk mengirimkan total pembayaran.",
    other_note: "Catatan Lain",
    other_note_holder: "Contoh: Apabila Anda ingin menggunakan bubble wrap, silahkan tambahkan pada catatan transaksi.",
    product_catalog: "Katalog Produk",
    add_or_remove_product: "Tambahkan/Hapus Produk",
    add_product: "Tambahkan Produk",
    remove_product: "Hapus Produk",
    promotion_links: "Link Promosi",
    promotion_link_desc: "Link-link ini akan ditampilkan pada halaman Profil Anda.",
    enter_title: "Masukkan Judul",
    add_new_link: "Tambah Link Baru",
    online_storefront: "Etalase Toko Online",
    online_storefront_desc: "Aktifkan fitur etalase toko online pada akun bisnis Anda.",
    online_storefront_status: "Status Etalase Toko",
    online_storefront_open_store: "Buka Toko",
    online_storefront_store_information: "Informasi Toko",
    online_storefront_image: "Gambar Toko",
    online_storefront_domain: "Domain Toko",
    online_storefront_domain_desc: "Link ini akan digunakan oleh pelanggan untuk membeli produk Anda secara online.",
    online_storefront_domain_holder: "Mis: jubelio",
    online_storefront_domain_confirm: "Link domain bersifat permanen dan Anda tidak dapat mengubahnya lagi. Apakah Anda ingin melanjutkan?",
    online_storefront_domain_error: "Nama toko ini tidak tersedia, harap mengisikan nama lainnya.",
    manage_online_storefront: "Kelola etalase toko online",
    manage_online_storefront_cap: "Kelola Etalase Toko Online",
    access_all_processed_orders: "Akses seluruh pesanan yang telah diproses",
    please_enter_domain_link: "Harap isikan link domain",
    required_to_fill: "Wajib untuk diisi",
    no_promotion_link_available: "Tidak ada link promosi yang tersedia",
    link_is_not_valid: "Link is not valid",
    no_product_found: "Produk tidak ditemukan",
    successful_saved: "Berhasil Disimpan",
    store_open_now: "Toko Anda telah dibuka",
    store_close_now: "Toko Anda telah ditutup",
    product_catalog_empty_alert: "Katalog produk Anda kosong. Apakah Anda ingin melanjutkan menyimpan etalase toko online Anda dengan produk kosong?",
    product_catalog_remove_last_alert: 'Apabila Anda menghapus produk ini, katalog produk Anda akan kosong. Apakah Anda ingin melanjutkan?',
    unsaved_change: "Perubahan Tidak Disimpan",
    unsaved_change_message: "Apakah Anda yakin ingin lanjut tanpa menyimpan?",
    process_online_storefront_order: "Proses pesanan etalase toko online",
    help: 'Bantuan',
    hello: 'Halo',
    need_some_help: 'Butuh bantuan?',
    feel_free_contact: 'Silahkan hubungi kami kapan pun Anda membutuhkan bantuan melalui kontak di bawah ini',
    call: 'Telepon',
    whats_app_message: 'Pesan WhatsApp',
    help_any_time: '{} kami siap membantu Anda kapan pun Anda butuhkan.',
    page_missing: 'OOPS! HALAMAN TIDAK DITEMUKAN!',
    page_missing_content: 'MAAF TAPI HALAMAN INI TIDAK DAPAT DITEMUKAN.',
    back_to_home: 'Kembali ke Beranda',
    continue: "Lanjutkan",
    cancel: "Batal",
    workspace: "Lingkungan Kerja",
    username: "Username",
    login_page: LoginPage,
    set_new_signin_password: 'Atur Kata Sandi Baru',
    recommend_change_password: 'Kami merekomendasikan Anda mengganti kata sandi untuk proses masuk selanjutnya. Apabila Anda lupa kata sandi ini, Anda harus meminta pemilik akun bisnis untuk mengubahnya.',
    initial_password: 'Kata Sandi Awal',
    update_password: 'Perbarui Kata Sandi',
    initial_password_validation: 'Kata sandi setidaknya harus memiliki',
    characters: 'karakter',
    automatically_assigned_to_all_stores: 'Tugaskan ke semua toko secara otomatis',
    automatically_assigned_to_all_stores_desc: 'Karyawan ini akan secara otomatis ditugaskan ke seluruh toko Anda, termasuk toko yang baru. Apakah Anda ingin melanjutkan?',
    e_wallet: 'E-WALLET',
    e_wallet_mobile_phone_number: 'Nomor Handphone E-Wallet',
    payment_note: "Catatan Pembayaran",
    payment_name: "Nama Pembayaran",
    active: 'Aktif',
    rejected: 'Ditolak',
    audit_log: 'Log Audit',
    object: 'Objek',
    before_changes: 'Sebelum Perubahan',
    after_changes: 'Setelah Perubahan',
    see_detail: 'Lihat Detail',
    changes_detail: 'Detail Perubahan',
    no_audit_log_found: 'Log Audit Tidak Ditemukan',
    all_objects: "Semua Objek",
    field: "Field",
    item_inventory: "Barang - Inventori",
    recommended_product: "Rekomendasikan Produk",
    recommend: "REKOMENDASIKAN",
    remove: "HAPUS",
    recommended_items: "Barang yang Direkomendasikan",
    you_are_not_add_recommend_items: "Anda belum menambahkan rekomendasikan barang. Mulailah dengan mengklik tombol “REKOMENDASIKAN” pada daftar barang di bawah ini.",
    you_can_only_add_up_to_10_product: "Anda hanya bisa menambahkan hingga 10 produk sebagai barang yang direkomendasikan",
    reset: "Reset",
    zoom_in: "Zoom In",
    zoom_out: "Zoom In",
    rotate_plus_90: "Rotate +90deg",
    rotate_minus_90: "Rotate -90deg",
    object_name: "Nama Objek",
    deactivate_payment_type: "Jika kamu menonaktifkan metode pembayaran ini, toko kamu tidak akan dapat menerima transaksi online. Apakah kamu ingin menonaktifkannya?",
    sobat_store: "Sobat Store",
    sobat_catalog_description: "Sobat Catalog Description",
}
